import { alpha, Box, darken, Stack, Tooltip, useTheme } from "@mui/material";
import { ReactElement } from "react";

interface TooltipMuiProps {
  color?: string;
  valueX: string | number;
  valueY?: string | number;
  valueZ?: string | number;
  children: ReactElement;
}
function TooltipMui({
  color,
  valueX,
  valueY,
  valueZ,
  children,
}: TooltipMuiProps) {
  const theme = useTheme();
  const styles = {
    container: {
      padding: "8px",
      color: theme.palette.text.primary,
      background: alpha(theme.palette.background.default, 0.9),
      backdropFilter: "blur(11px)",
      borderRadius: 4,
      fontSize: "0.875rem",
      textAlign: "center" as const,
      justifyContent: "center",
      alignItems: "center",
      gap: 8,
      display: "flex",
      flexDirection: "row" as const,
    },
    dot: {
      width: "12px",
      height: "12px",
      backgroundColor: color,
      borderRadius: "50%",
      border: color && `1px solid ${darken(color as string, 0.2)}`,
      flexShrink: 0,
    },
  };
  return (
    <Tooltip
      placement="top"
      followCursor
      slotProps={{
        tooltip: {
          sx: {
            p: 0,
            m: 0,
            bgcolor: "transparent",
          },
        },
      }}
      title={
        <div style={styles.container}>
          {color && <div style={styles.dot} />}
          {valueX} {valueY ? " - " + valueY : ""}
          {valueZ ? ":" : ""} <span style={{ fontWeight: 700 }}>{valueZ}</span>
        </div>
      }
    >
      {children}
    </Tooltip>
  );
}
export default TooltipMui;
